/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreorderPropertyInfoDto } from './preorder-property-info-dto';
import {
    PreorderPropertyInfoDtoFromJSON,
    PreorderPropertyInfoDtoFromJSONTyped,
    PreorderPropertyInfoDtoToJSON,
    PreorderPropertyInfoDtoToJSONTyped,
} from './preorder-property-info-dto';
import type { PreorderPriceInfoDto } from './preorder-price-info-dto';
import {
    PreorderPriceInfoDtoFromJSON,
    PreorderPriceInfoDtoFromJSONTyped,
    PreorderPriceInfoDtoToJSON,
    PreorderPriceInfoDtoToJSONTyped,
} from './preorder-price-info-dto';
import type { AdditionalServiceInfoDto } from './additional-service-info-dto';
import {
    AdditionalServiceInfoDtoFromJSON,
    AdditionalServiceInfoDtoFromJSONTyped,
    AdditionalServiceInfoDtoToJSON,
    AdditionalServiceInfoDtoToJSONTyped,
} from './additional-service-info-dto';
import type { PersonInfoDto } from './person-info-dto';
import {
    PersonInfoDtoFromJSON,
    PersonInfoDtoFromJSONTyped,
    PersonInfoDtoToJSON,
    PersonInfoDtoToJSONTyped,
} from './person-info-dto';
import type { PreorderRoomInfoDto } from './preorder-room-info-dto';
import {
    PreorderRoomInfoDtoFromJSON,
    PreorderRoomInfoDtoFromJSONTyped,
    PreorderRoomInfoDtoToJSON,
    PreorderRoomInfoDtoToJSONTyped,
} from './preorder-room-info-dto';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';

/**
 * 
 * @export
 * @interface CreateBookingResponseDto
 */
export interface CreateBookingResponseDto {
    /**
     * Уникальный числовой код заказа
     * @type {string}
     * @memberof CreateBookingResponseDto
     */
    orderNumber: string;
    /**
     * URL для проведения платежа
     * @type {string}
     * @memberof CreateBookingResponseDto
     */
    paymentUrl: string;
    /**
     * Дата до которой бронь держится без оплаты
     * @type {string}
     * @memberof CreateBookingResponseDto
     */
    bookingTimeout: string;
    /**
     * 
     * @type {PreorderPropertyInfoDto}
     * @memberof CreateBookingResponseDto
     */
    propertyInfo: PreorderPropertyInfoDto;
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof CreateBookingResponseDto
     */
    bookingInfo: TravelineBookingStayDatesDto;
    /**
     * 
     * @type {PreorderRoomInfoDto}
     * @memberof CreateBookingResponseDto
     */
    roomInfo: PreorderRoomInfoDto;
    /**
     * 
     * @type {PreorderPriceInfoDto}
     * @memberof CreateBookingResponseDto
     */
    priceInfo: PreorderPriceInfoDto;
    /**
     * Список с персональными и контактными данными клиента и гостей
     * @type {Array<PersonInfoDto>}
     * @memberof CreateBookingResponseDto
     */
    personInfo: Array<PersonInfoDto>;
    /**
     * 
     * @type {Array<AdditionalServiceInfoDto>}
     * @memberof CreateBookingResponseDto
     */
    additionalServices: Array<AdditionalServiceInfoDto>;
}

/**
 * Check if a given object implements the CreateBookingResponseDto interface.
 */
export function instanceOfCreateBookingResponseDto(value: object): value is CreateBookingResponseDto {
    if (!('orderNumber' in value) || value['orderNumber'] === undefined) return false;
    if (!('paymentUrl' in value) || value['paymentUrl'] === undefined) return false;
    if (!('bookingTimeout' in value) || value['bookingTimeout'] === undefined) return false;
    if (!('propertyInfo' in value) || value['propertyInfo'] === undefined) return false;
    if (!('bookingInfo' in value) || value['bookingInfo'] === undefined) return false;
    if (!('roomInfo' in value) || value['roomInfo'] === undefined) return false;
    if (!('priceInfo' in value) || value['priceInfo'] === undefined) return false;
    if (!('personInfo' in value) || value['personInfo'] === undefined) return false;
    if (!('additionalServices' in value) || value['additionalServices'] === undefined) return false;
    return true;
}

export function CreateBookingResponseDtoFromJSON(json: any): CreateBookingResponseDto {
    return CreateBookingResponseDtoFromJSONTyped(json, false);
}

export function CreateBookingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBookingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orderNumber': json['orderNumber'],
        'paymentUrl': json['paymentUrl'],
        'bookingTimeout': json['bookingTimeout'],
        'propertyInfo': PreorderPropertyInfoDtoFromJSON(json['propertyInfo']),
        'bookingInfo': TravelineBookingStayDatesDtoFromJSON(json['bookingInfo']),
        'roomInfo': PreorderRoomInfoDtoFromJSON(json['roomInfo']),
        'priceInfo': PreorderPriceInfoDtoFromJSON(json['priceInfo']),
        'personInfo': ((json['personInfo'] as Array<any>).map(PersonInfoDtoFromJSON)),
        'additionalServices': ((json['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoFromJSON)),
    };
}

  export function CreateBookingResponseDtoToJSON(json: any): CreateBookingResponseDto {
      return CreateBookingResponseDtoToJSONTyped(json, false);
  }

  export function CreateBookingResponseDtoToJSONTyped(value?: CreateBookingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderNumber': value['orderNumber'],
        'paymentUrl': value['paymentUrl'],
        'bookingTimeout': value['bookingTimeout'],
        'propertyInfo': PreorderPropertyInfoDtoToJSON(value['propertyInfo']),
        'bookingInfo': TravelineBookingStayDatesDtoToJSON(value['bookingInfo']),
        'roomInfo': PreorderRoomInfoDtoToJSON(value['roomInfo']),
        'priceInfo': PreorderPriceInfoDtoToJSON(value['priceInfo']),
        'personInfo': ((value['personInfo'] as Array<any>).map(PersonInfoDtoToJSON)),
        'additionalServices': ((value['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoToJSON)),
    };
}

